module.exports = __webpack_public_path__ + "static/reframer-330d65a59d23c9c17cb8a9f2fcecd3a6.png";